import { RsVermieterActions, RsVermietungAction } from '../rs-vermietung-actions.service';
import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: RsVermietungAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case RsVermieterActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
